"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _baseCustomValidators = /*#__PURE__*/ _interopRequireDefault(require("../validators/BaseCustomValidators"));
var _errors = require("../errors");
var _typeValidators = /*#__PURE__*/ _interopRequireDefault(require("../validators/TypeValidators"));
var _valueValidators = /*#__PURE__*/ _interopRequireDefault(require("../validators/ValueValidators"));
function _checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _classPrivateFieldGet(receiver, privateMap) {
    var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
    return _classApplyDescriptorGet(receiver, descriptor);
}
function _classPrivateFieldInit(obj, privateMap, value) {
    _checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
    _classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _schema = /*#__PURE__*/ new WeakMap(), _schemaMap = /*#__PURE__*/ new WeakMap(), _customValidators = /*#__PURE__*/ new WeakMap();
var BaseModel = /*#__PURE__*/ function() {
    "use strict";
    function BaseModel(schema, schemaMap) {
        var CustomValidatorClass = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _baseCustomValidators.default;
        _classCallCheck(this, BaseModel);
        _classPrivateFieldInit(this, _schema, {
            writable: true,
            value: void 0
        });
        _classPrivateFieldInit(this, _schemaMap, {
            writable: true,
            value: void 0
        });
        _classPrivateFieldInit(this, _customValidators, {
            writable: true,
            value: void 0
        });
        _classPrivateFieldSet(this, _schema, schema);
        _classPrivateFieldSet(this, _schemaMap, schemaMap);
        _classPrivateFieldSet(this, _customValidators, CustomValidatorClass);
    }
    var _proto = BaseModel.prototype;
    _proto.validate = function validate(parameters) {
        var _this = this;
        return this.schema.parameters.map(function(p) {
            if (parameters[p.name] === undefined && p.isOptional) return {
                name: p.name,
                isValid: true,
                errors: []
            };
            return _this.validateParameter(p.name, parameters[p.name], parameters);
        });
    };
    _proto.validateParameter = function validateParameter(name, value, allParameters) {
        var paramInfo = this.schemaMap.parameters[name];
        var result = {
            name: name,
            isValid: false,
            errors: []
        };
        if (!paramInfo) {
            result.errors.push(_errors.ParameterErrors.PARAMETER_NOT_IN_SCHEMA);
            return result;
        }
        if (!_typeValidators.default.validate(paramInfo, value)) {
            result.errors.push(_errors.ParameterErrors.PARAMETER_TYPE_INVALID);
            return result;
        }
        if (!_valueValidators.default.validate(paramInfo, value)) {
            result.errors.push(_errors.ParameterErrors.PARAMETER_VALUE_INVALID);
            return result;
        }
        var customValidationResults = _classPrivateFieldGet(this, _customValidators).validate(paramInfo, value, allParameters);
        if (!customValidationResults.isValid) {
            if (!customValidationResults.errors) {
                result.errors.push(_errors.ParameterErrors.PARAMETER_CUSTOM_INVALID);
            } else {
                result.errors = customValidationResults.errors;
            }
            if (customValidationResults.errorContext) {
                result.errorContext = customValidationResults.errorContext;
            }
            return result;
        }
        result.isValid = true;
        return result;
    };
    _createClass(BaseModel, [
        {
            key: "schema",
            get: function get() {
                return _classPrivateFieldGet(this, _schema);
            }
        },
        {
            key: "schemaMap",
            get: function get() {
                return _classPrivateFieldGet(this, _schemaMap);
            }
        }
    ]);
    return BaseModel;
}();
var _default = BaseModel;
